module.exports = __webpack_public_path__ + "img/pitch-active.766d5024.svg";